import React, { useMemo } from 'react';
import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { useRouter } from '@/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { useSiteStore } from '@/store/site';
import { useAccountInfo } from '@/hooks/query/account';
import { convertCultureToRef } from '@/utils/common-util';
import { AnalyseKey, useConfigsAnalyseAttribute } from '@/features/next-analyse';

const supportLanguages = ['en', 'cs', 'zhcn', 'ch', 'th', 'vn', 'jp', 'ko', 'id', 'tr'];

interface BetterEsoccerBattleSliderProps {
	onClose: () => void;
}

export const BetterEsoccerBattleSlider: React.FC<BetterEsoccerBattleSliderProps> = ({
	onClose,
}) => {
	const router = useRouter();
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const view = useAppearanceStore(state => state.view);
	const [setCurrentPage] = useSiteStore(state => [state.setCurrentPage]);
	const locale = useLocale();

	const shortLang = convertCultureToRef(locale ?? 'en-US');
	const lang = supportLanguages.includes(shortLang) ? shortLang === 'zhcn' ? 'cs' : shortLang : 'en';

	const loginPopupBanner112CtaAnalyseConfigs = useMemo(
		() => [{ key: 'switch-to-odds-page-via-login-popup-banner-112', analyseKey: AnalyseKey.Refined }],
		[],
	);
	const loginPopupBanner112CtaAnalyseRef = useConfigsAnalyseAttribute(loginPopupBanner112CtaAnalyseConfigs);

	const handleClickButton = async () => {
		// setKafkaNormal({
		// 	note: KafkaNote.Betby,
		// 	type: view == ViewEnum.mars ? 1 : 2,
		// 	action: 6,
		// });
		setCurrentPage('lbl_VirtualSport');
		router.push('/sports/112');
		onClose();
	};

	return (
		<div className="better-esoccer-battle-modal">
			<Image 
				src={`/images/promotion-activity-modal/better-esoccer-battle-slider/better-esoccer-${lang}.png`}
				alt=""
				width="288"
				height="360"
				className="better-esoccer-battle-modal__image"
				isGalaxyFolder={true}
			/>
			<button
				ref={loginPopupBanner112CtaAnalyseRef}
				className="better-esoccer-battle-modal__btn"
				onClick={handleClickButton}
			>
				{t('lbl_eSoccerBattlePopup03')}
			</button>
		</div>
	);
};